import { reportsStoreFeatureName as defaultFeatureName } from '../consts';

// remove after details (every reports state) are migrated
export const safeReportsStateSelector = (
  state: any,
  namespace: string,
  initilalState: any,
  reportsStoreFeatureName = defaultFeatureName,
) => {
  const reportsState = reportsStoreFeatureName in state ? state[reportsStoreFeatureName] : null;
  if (reportsState && namespace in reportsState) {
    return reportsState[namespace];
  }
  return initilalState;
};
